"use client";

import PractitionersContainer from "./components/PractitionersContainer/PractitionersContainer";
import PractitionersCard from "./components/PractitionersContainer/components/PractitionersCard/PractitionersCard";
import PractitionersInfo from "./components/PractitionersContainer/components/PractitionersInfo";

const Practitioners = ({ revenueGrowth }) => {
  return (
    <div className="pt-24 w-full  ">
      <PractitionersContainer>
        <div className="max-w-5xl container mx-auto  ">
          <PractitionersInfo />
          <PractitionersCard revenueGrowth={revenueGrowth} />
        </div>
      </PractitionersContainer>
    </div>
  );
};

export default Practitioners;
